"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixCommandsWithMissingArg = fixCommandsWithMissingArg;
const tex_syntax_1 = require("./tex-syntax");
const unaryCommand = `(?:${tex_syntax_1.color}|rlap)`;
function fixCommandsWithMissingArg(tex) {
    return (tex
        // Color commands that are all by themselves in braces: {\pink}
        .replace(new RegExp(`{\\s*(\\\\${unaryCommand}\\s*)+}`, "g"), "{}")
        // Color commands that are at the end of a string: funky \orange
        .replace(new RegExp(`\\s*(\\\\${unaryCommand}\\s*)+$`, "g"), "")
        // Color commands that at the end of a block: \text{electric \purple}
        .replace(new RegExp(`\\s*\\\\${unaryCommand}\\s*}`, "g"), "}"));
}
